import { ReportingControllerBaseConfig } from '../../base';
import { HeadingBlockController } from './headingBlockInterface';
import { HeadingBlockViewProps } from './headingBlockProps';
import { createBlockItemController } from '../block';

export function createHeadingBlockController(
    config: ReportingControllerBaseConfig
): HeadingBlockController {
    const blockController = createBlockItemController();
    return {
        useProps(context, item, props): Omit<HeadingBlockViewProps, 'children'> {
            const block = blockController.useProps(context, item, props.item);
            return {
                block,
                placeholder: props.item.adapter.isEmpty ? `Heading ${props.level}` : null,
                level: props.level,
            };
        },
    };
}
